import { Box, Typography, Divider, Card, CardContent, Button } from "@mui/material";

const Mobile = ({ newEntregas, getStatus, setOpen, setInfo }) => {
  return newEntregas.map((entrega) => {
    const { id, data, productsArr } = entrega;

    let productsArray = productsArr.split(";");

    productsArray = productsArray.filter(
      (unique, index) => productsArray.indexOf(unique) === index,
    );

    return (
      <Card
        key={id}
        elevation={2}
        sx={{
          borderRadius: 3,
          width: "100%",
          cursor: "pointer",
          mb: 2,
        }}
      >
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Box flex={1} display="flex" flexDirection="column">
              <Typography variant="subtitle1">
                <strong>Data: </strong>
                {data}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Produtos: </strong>
                {productsArray[0] +
                  (productsArray.length > 1 ? ` e mais ${productsArray.length - 1} produtos` : "")}
              </Typography>
            </Box>
          </Box>
          <Divider sx={{ mb: 1 }} />
          <Button
            variant="outlined"
            sx={{ mb: 1 }}
            fullWidth
            onClick={() => {
              getStatus(
                entrega.numnota,
                entrega.details,
                setOpen,
                setInfo,
                entrega.productsArr,
                entrega.qtdsArr,
                entrega.seriesArr,
              );
            }}
          >
            Ver Detalhes
          </Button>
        </CardContent>
      </Card>
    );
  });
};

export default Mobile;
